import * as api from "../api";

export default {
  data() {
    return {
      edit_set_name:'',
      edit_set_id:0,

      is_can_change:true,
      link:$('#app-wrapper').attr('link'),
      is_editable_works: ($('#app-wrapper').attr('is_editable_works')==1),//юзер-владелец может добавлять/редактировать
      is_editor: ($('#app-wrapper').attr('is_editor')==1),//наш редактор/модератор
      to_artist_id: $('#app-wrapper').attr('artist_id'),
      spaceBetween: 0,
    }
  },
  computed: {
    artist_sets () {
      let cur=this.$store.getters.artistCollections['artist_sets'];
      if ( cur!=null && cur.length>0 ){
        setTimeout(()=>{
          this.init_collections_menu();
        }, 250);
      }
      return cur;
    },
    cover_works_media () {
      return this.$store.getters.artistCollections['cover_works_media'];
    },

    acollection: {
      get () {
        return this.$store.getters.filters.acollection;
      },

      set (value) {
        if (value) {
          this.$store.dispatch ('setFilters', {'p':1, acollection: value.toString()}).then (() => { });
        } else {
          this.$store.dispatch ('setFilters', {'p':1, acollection: false}).then (() => { });
        }
      },
    }
  },

  methods: {
    change( set_id ){
      if ( !this.is_can_change ) return;
      if ( this.acollection===set_id ) this.acollection='';
      else this.acollection=set_id;
      $('.c_works_actions').hide();
    },

    show_rename( set_id, set_name ){
      this.is_can_change=false;

      this.edit_set_id=set_id;
      this.edit_set_name=set_name;

      setTimeout( ()=>{
        window.model_big_popup.show('id_dialog_rename_collection');
        $(this.$refs.input_name).focus();

        this.is_can_change=true;
      }, 50 );
    },

    close_popup(){
      window.model_big_popup.close_all();
    },

    //переименовываем коллекцию
    do_save_new_name( event ){
      if ( this.edit_set_id<=0 ) return;
      let name=$.trim( this.edit_set_name );
      if ( name.length==0 ){
        window.show_err_mes( this.$t('message.ErrEmptyNameCollection') );
        $(this.$refs.input_name).focus();
        return;
      }

      let o_btn=this.$refs.button_save;

      window.global.make_loading( o_btn );
      var url = '/action/vue/artists/rename-collection';
      api.post(url, {set_id: this.edit_set_id, name:name}).then(response => {
        window.global.restore_post_jobj(o_btn);

        if(response.data.status==='success'){
          window.show_info_mes( response.data.mes );
          window.model_big_popup.close_all();

          //рефреш
          this.$store.dispatch('getArtistCollections', {artist_id: this.to_artist_id}).then( ()=>{} );
        }
        else{
          $(this.$refs.input_name).focus();
          window.show_err_mes( response.data.mes );
          console.log(response.data.error);
        }
      }).catch(e => {
        console.log(e)
      });
    },

    //удаляем коллекцию
    do_remove( event, set_id ){
      this.is_can_change=false;

      window.model_dialog.confirm( this.$t('message.RemoveCollectionConfirm'),
        //ok
        ()=>{
          let j_o=$(event.target).parents('.dropdown:first');
          window.global.make_loading( j_o );

          var url = '/action/vue/artists/remove-collection';
          api.post(url, {set_id: set_id}).then(response => {
            window.global.restore_post_jobj( j_o );

            if(response.data.status==='success'){
              this.acollection='';
              window.show_info_mes( response.data.mes );
              //рефреш
              this.$store.dispatch('getArtistCollections', {artist_id: this.to_artist_id}).then( ()=>{} );
            }
            else{
              window.show_err_mes( response.data.mes );
              console.log(response.data.error);
            }
          }).catch(e => {
            console.log(e)
          });

          setTimeout( ()=>{ this.is_can_change=true }, 50 );
        },

        //cancel
        ()=>{
          setTimeout( ()=>{ this.is_can_change=true }, 50 );
        }
      );
    },

    get_cover_url(work_id){
      let hasWindow = typeof window !== 'undefined';
      let environment = (hasWindow ? window.devicePixelRatio || 1 : 1);
      if (environment>=1.25) environment=2;
      environment=Math.round(environment);

      let add='';
      if ( environment>1 ) add='@2x';

      let media_info=this.cover_works_media[work_id];
      if ( media_info==null || media_info.length===0 ) return '';
      return media_info['base_url']+'/img/sx80/'+media_info['use_type']+'/'+media_info['data']['version']+'/'+media_info['media_id']+add+'.'+media_info['data']['ext'];
    },

    init_collections_menu(){
      let vue=this;
      $( function(){
        let j_container = $(vue.$refs.collection_slider_container);
        if ( j_container.data('sliderinited')==1 ) return;
        j_container.data('sliderinited', 1);

        let slider=window.model_ui5.init_swiper('id_swiper_collection', vue.spaceBetween);

        slider.on('touchMove', function (e) {
          if ( e.movementX < 0 ) {
            j_container.addClass('active');
          } else {
            if ( slider.activeIndex == 0 ) {
              j_container.removeClass('active');
            }
          }
        });

        slider.on('slideChange', function () {
          slider.activeIndex > 0 ? j_container.addClass('active') : j_container.removeClass('active')
        });

        if ( vue.acollection>0 ){
          let num=-1;
          $('.swiper-slide', j_container).each( function(n, o){
            if ( $(o).attr('set_id')==vue.acollection ) num=n;
          } );
          if ( num>=0 ) slider.slideTo(num);
        }
      } );
    },
  },

  created() {
    this.$store.dispatch('getArtistCollections', {artist_id: this.to_artist_id}).then( ()=>{
      //console.log( this.$store.getters.artistCollections );
      /*setTimeout(()=>{
        this.init_collections_menu();
      }, 250);*/
    } );
  },

  /*mounted() {
    //this.init_collections_menu();
  },*/
}



//////////////////
// WEBPACK FOOTER
// ./src/components/ArtistCollectionsMix.js
// module id = null
// module chunks = 